import React from "react";
import _ from "lodash";
import { AudioString } from "components/flink-components";

const { getRuntimeTextField } = require("./stringTextField");

export default (strings, locale) => (
  stringNumber,
  defaultText,
  isTooltip,
  forHelp,
  localeOverride,
  isAudio,
) => {
  const search = _.find(
    strings,
    (item) => Number(item?.stringNumber) === Number(stringNumber)
  );
  const activeLocale = localeOverride || locale;
  const string = _.get(search?.data, activeLocale);
  const englishString = _.get(search?.data, 'en') || {};

  if (!string) {
    return defaultText || "Translate not found";
  }

  if (isAudio && (string.stringAudio || string.audio)) {
    return <AudioString string={string} locale={activeLocale} />;
  }

  if (isTooltip) {
    return string.stringValue;
  }

  const runtimeText = getRuntimeTextField({
    englishData: englishString,
    localeData: string,
  });

  if (forHelp) {
    return runtimeText.value;
  }

  return runtimeText.field === 'prettyValue' && runtimeText.value ? (
    <span dangerouslySetInnerHTML={{ __html: runtimeText.value }} />
  ) : (
    runtimeText.value || defaultText || "Translate not found"
  );
};
